/* eslint-disable no-unused-vars */
import { observable, action, makeObservable } from 'mobx';
//测评
class Evaluation {
    constructor() {
        makeObservable(this);
    }

    //页面模式
    @observable mode = 'login'; //login/question/complete
    @action
    setMode = (data) => {
        this.mode = data;
    };

    //页面参数
    @observable publicParams = {};
    @action
    setPublicParams = (data) => {
        this.publicParams = data;
    };

    //公开测评 - 用户参数
    @observable userMobile = '';
    @action
    setUserMobile = (data) => {
        this.userMobile = data;
    };
    //公开测评 - 用户参数
    @observable userName = '';
    @action
    setUserName = (data) => {
        this.userName = data;
    };

    //配置数据
    @observable evaluationConfigData = {
        finish_conclusion: '',
        identity_verification: 1,
        name_verification: 1,
        navigation_verification: 1,
        navigation_name: '',
        navigation_link: '',
        navigation_remark: '',
        title: '',
        pc_jump_url: ''
    };
    @action
    setEvaluationConfigData = (data) => {
        this.evaluationConfigData = data;
    };
    //测评信息
    @observable evaluationInfo = {
        bucket_name: '',
        file_name: '',
        start_time: 0,
        end_time: 0,
        end_state: 0,
        ongoing_status: 0
    };
    @action
    setEvaluationInfo = (data) => {
        this.evaluationInfo = data;
    };

    //第三方问卷参数
    @observable paramString = '';
    setParamString = (data) => {
        this.paramString = data;
    };
}
export default new Evaluation();
